import PermissionsShowContainer from './permissions_show_container';

const PermissionsShow = PermissionsShowContainer;

export default PermissionsShow;
